<template>
   <div class="html-editor">
      <BaseHeader 
         :editor="editor" 
         @setLink="setLink()"
         @addIllustration="addIllustration()"
         @addKop="addKop()"
         @addCitaat="addCitaat()" 
         @lijstaanhef="editor.chain().focus().toggleSpanClass('lijstaanhef').run()"
         @lijstsluiting="editor.chain().focus().toggleSpanClass('lijstsluiting').run()"
         @ExtRef="addRef('ExtRef')"
         @ExtIoRef="addRef('ExtIoRef')"
         @IntRef="addRef('IntRef')"
         @IntIoRef="addRef('IntIoRef')"
      />
      <!-- <header class="editor-menu" v-if="editor"> -->
         

         <!-- <button
            @click="
               editor
                  .chain()
                  .focus()
                  .insertTable({ rows: 3, cols: 2, withHeaderRow: true })
                  .run()
            "
         >
            <span class="material-icons"> calendar_view_month </span>
            <span class="tooltip">Tabel invoegen</span>
         </button> -->
         <!-- <div class="tableOptions">
            <button
               @click="editor.chain().focus().addColumnBefore().run()"
               :disabled="!editor.can().addColumnBefore()"
            >
               addColumnBefore
            </button>
            <button
               @click="editor.chain().focus().addColumnAfter().run()"
               :disabled="!editor.can().addColumnAfter()"
            >
               addColumnAfter
            </button>
            <button
               @click="editor.chain().focus().deleteColumn().run()"
               :disabled="!editor.can().deleteColumn()"
            >
               deleteColumn
            </button>
            <div class="separator"></div>
            <button
               @click="editor.chain().focus().addRowBefore().run()"
               :disabled="!editor.can().addRowBefore()"
            >
               addRowBefore
            </button>
            <button
               @click="editor.chain().focus().addRowAfter().run()"
               :disabled="!editor.can().addRowAfter()"
            >
               addRowAfter
            </button>
            <button
               @click="editor.chain().focus().deleteRow().run()"
               :disabled="!editor.can().deleteRow()"
            >
               deleteRow
            </button>
            <div class="separator"></div>
            <button
               @click="editor.chain().focus().deleteTable().run()"
               :disabled="!editor.can().deleteTable()"
            >
               deleteTable
            </button>
            <button
               @click="editor.chain().focus().mergeCells().run()"
               :disabled="!editor.can().mergeCells()"
            >
               mergeCells
            </button>
            <button
               @click="editor.chain().focus().splitCell().run()"
               :disabled="!editor.can().splitCell()"
            >
               splitCell
            </button>
            <div class="separator"></div>
            <button
               @click="editor.chain().focus().toggleHeaderRow().run()"
               :disabled="!editor.can().toggleHeaderRow()"
            >
               toggleHeaderRow
            </button>
         </div> -->
         <!-- <button
            title="Uppercase"
            @click="editor.chain().focus().toggleSpanClass('jesse').run()"
            :class="{
               'is-active':
                  editor.isActive('textStyle') &&
                  editor.getAttributes('textStyle').spanClass.includes('jesse'),
            }"
         >
            Uppercase
         </button> -->
         <!-- <button
            title="Block"
            @click="editor.chain().focus().toggleBlockClass('block-cool').run()"
            :class="{
               'is-active':
                  editor.isActive('textStyle') &&
                  editor.getAttributes('textStyle').blockClass.includes('block-cool'),
            }"
         >
            Block
         </button> -->
      <!-- </header> -->
      <BubbleMenu
         :editor="editor"
         v-if="editor"
         :shouldShow="shouldShow('second')"
      >
         Test
      </BubbleMenu>
      <BubbleMenu
         :editor="editor"
         v-if="editor"
         :shouldShow="shouldShow('hi there')"
      >
         <button
            @click="editor.chain().focus().toggleBold().run()"
            :class="{ 'is-active': editor.isActive('bold') }"
         >
            bold
         </button>
         <input type="text" />
         <button
            @click="editor.chain().focus().toggleItalic().run()"
            :class="{ 'is-active': editor.isActive('italic') }"
         >
            italic
         </button>
         <button
            @click="editor.chain().focus().toggleStrike().run()"
            :class="{ 'is-active': editor.isActive('strike') }"
         >
            strike
         </button>
      </BubbleMenu>
      <editor-content class="content" @blur="doAction()" :editor="editor" />
      <button @click="doAction()">Send</button>
   </div>
</template>

<script>
import BaseHeader from "@/components/BaseHeader";
import { Editor, EditorContent, BubbleMenu } from "@tiptap/vue-2";
import StarterKit from "@tiptap/starter-kit";
import Table from "@tiptap/extension-table";
import TableRow from "@tiptap/extension-table-row";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import Image from "@tiptap/extension-image";
import Superscript from "@tiptap/extension-superscript";
import Subscript from "@tiptap/extension-subscript";
import Link from "@tiptap/extension-link";
import Focus from "@tiptap/extension-focus";

//import NodeView from "./ExtensionNew.js";
import Illustratie from "./Illustratie/Illustratie.js";
import Kop from "./Kop/Kop.js";
import Citaat from "./Citaat/Citaat.js";
import Ref from "./Ref/Ref.js";

// import BaseMenu from "@/components/base/Menu/Menu";

//import CustomStyle from "@/components/base/listHeader/listHeader.js";

//import { Extension } from "@tiptap/core";
import "@tiptap/extension-text-style";
import TextStyle from "@tiptap/extension-text-style";
import { SpanClass } from "@/components/base/listHeader/listHeader.js";
//import { BlockClass } from "@/components/base/listHeader/block.js";

export default {
   components: {
      BaseHeader,
      EditorContent,
      BubbleMenu,
   },
   props: {
      content: {
         default: "This is default",
      },
   },
   data() {
      return {
         editor: null,
         imageName: "Arnold.jpg",
         openModal: false,
      };
   },

   mounted() {
      this.editor = new Editor({
         content: this.content,
         extensions: [
            StarterKit,
            Table.configure({
               lastColumnResizable: false,
            }),
            TableRow,
            TableHeader,
            // Default TableCell
            TableCell,
            Image,
            Superscript,
            Subscript,
            Link.configure({
               openOnClick: false,
            }),
            Focus.configure({
               className: "has-focus",
               mode: "all",
            }),
            Illustratie,
            Kop,
            Citaat,
            TextStyle,
            SpanClass,
            Ref,

            // BubbleMenu.configure({
            //    shouldShow: ({ editor}) => {
            //       // only show the bubble menu for images and links
            //       return editor.isActive("image") || editor.isActive("link");
            //    },
            // }),
            // BlockClass,
            //new CustomStyle(),
            // Custom TableCell with backgroundColor attribute
            //CustomTableCell,
         ],
      });
   },
   methods: {
      shouldShow(id) {
         console.log("param", id);
         return ({ editor }) => {
            // only show the bubble menu for images and links
            return (
               editor.isActive("textStyle") &&
               editor.getAttributes("textStyle").spanClass.includes("jesse")
            );
            //return editor.isActive("image") || editor.isActive("link");
         };
      },
      addIllustration() {
         this.editor.commands.insertContent(
            `<illustratie naam='${this.imageName}'/>`
         );
      },
      addKop() {
         this.editor.commands.insertContent(`<kop>Placeholder</kop>`);
      },
      addCitaat() {
         console.log("selection", this.editor.view.state.selection.content())
         this.editor.commands.insertContent(`<citaat>citaat</citaat>`);
      },
      addRef(el) {
         this.editor.commands.insertContent(`<ref>${el}</ref>`);
      },
      doAction() {
         console.log("Blur", this.editor.getHTML());
         this.$emit("send", this.editor.getHTML());
      },
      addImage() {
         const url = window.prompt("URL");

         if (url) {
            this.editor.chain().focus().setImage({ src: url }).run();
         }
      },
      setLink() {
         const previousUrl = this.editor.getAttributes("link").href;
         const url = window.prompt("URL", previousUrl);

         // cancelled
         if (url === null) {
            return;
         }

         // empty
         if (url === "") {
            this.editor
               .chain()
               .focus()
               .extendMarkRange("link")
               .unsetLink()
               .run();

            return;
         }

         // update link
         this.editor
            .chain()
            .focus()
            .extendMarkRange("link")
            .setLink({ href: url })
            .run();
      },
   },
   computed: {
      getFocus() {
         if (this.editor) {
            return this.editor.isFocused;
         }
         return false;
      },
   },
   watch: {
      getFocus() {
         this.doAction();
      },
   },

   beforeDestroy() {
      this.editor.destroy();
   },
};
</script>


<style lang="scss">
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");
.html-editor {
   --z-index-baseMenuOverlay: 98;
   --z-index-baseMenu: 99;
   border-radius: 4px;
   --header-hover-color: #ddd;
   --box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
      0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
   box-shadow: var(--box-shadow);
}
#styleSelector {
   &:hover {
      .tooltip {
         opacity: 1;
      }
   }
}

.list-item {
   width: 100%;
   justify-content: flex-start;
   padding-right: 1rem;
   padding-left: 1rem;
   height: 48px;
   border-radius: 0;
   font-size: 1rem;
}

.content {
   padding: 1rem;
}
.ProseMirror {
   outline: 0 !important;
   word-wrap: break-word;
   white-space: pre-wrap;
   white-space: break-spaces;
   -webkit-font-variant-ligatures: none;
   font-variant-ligatures: none;
   font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */

   > * + * {
      margin-top: 0.75em;
   }
   .image-container {
      padding: 1rem;
      background-color: #f6f6f6;
   }

   ul,
   ol {
      padding: 0 1rem;
   }

   h1,
   h2,
   h3,
   h4,
   h5,
   h6 {
      line-height: 1.1;
   }

   code {
      background-color: rgba(#616161, 0.1);
      color: #616161;
   }

   pre {
      background: #0d0d0d;
      color: #fff;
      font-family: "JetBrainsMono", monospace;
      padding: 0.75rem 1rem;
      border-radius: 0.5rem;

      code {
         color: inherit;
         padding: 0;
         background: none;
         font-size: 0.8rem;
      }
   }

   img {
      max-width: 100%;
      height: auto;
   }

   blockquote {
      padding-left: 1rem;
      border-left: 2px solid rgba(#0d0d0d, 0.1);
   }

   hr {
      border: none;
      border-top: 2px solid rgba(#0d0d0d, 0.1);
      margin: 2rem 0;
   }
}

/* Table-specific styling */
.ProseMirror {
   --max-width: 1200px;
   table {
      border-collapse: collapse;
      table-layout: fixed;
      width: 100%;
      max-width: var(--max-width);
      margin: 0;
      &.has-focus {
         box-shadow: 0 0 1px 1px var(--primary-color, #008fc1);
      }

      td,
      th {
         min-width: 1em;
         border: 1px solid #ced4da;
         padding: 1rem;
         vertical-align: top;
         box-sizing: border-box;
         position: relative;

         > * {
            margin-bottom: 0;
         }
      }

      th {
         font-weight: bold;
         text-align: left;
         background-color: #f1f3f5;
      }

      .selectedCell:after {
         z-index: 2;
         position: absolute;
         content: "";
         left: 0;
         right: 0;
         top: 0;
         bottom: 0;
         background: rgba(200, 200, 255, 0.4);
         pointer-events: none;
      }

      .column-resize-handle {
         position: absolute;
         right: -2px;
         top: 0;
         bottom: -2px;
         width: 4px;
         background-color: #adf;
         pointer-events: none;
      }

      p {
         margin: 0;
      }
   }
}

.tableWrapper {
   overflow-x: auto;
}

.resize-cursor {
   cursor: ew-resize;
   cursor: col-resize;
}

img {
   max-width: 125px;
}

.jesse {
   color: red;
   display: block;
}

.lijstaanhef, .lijstsluiting {
   display: block;
   color: green;
   border: 1px dashed #ddd;
   max-width: var(--max-width);
}
</style>

